/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileChecked = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22.707 17.707 18 22.414l-2.707-2.707 1.414-1.414L18 19.586l3.293-3.293z" />
        <path d="M20 7.586V15h-2V9h-5V4H6v16h7v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M14 17H8v-2h6zm2-4H8v-2h8zm-5-4H8V7h3z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileChecked as FileChecked };
